import React, { useEffect, useRef, useState } from 'react';
import { Transition } from 'react-transition-group';
import * as SS from '../styles/shared-styles';
import * as S from './style';
import useExtendedLocalStorage from '../../common/hooks/useExtendedLocalStorage';
import { GuestUserCreation } from '../../../services/loggedout-api';
import { SetGradeApi } from '../../../services/parent-api';
import { SetActiveCourse } from '../../../services/student-api';
import { validateEmail, validatePassword } from '../../../utils/web-helper';
import { useSelector } from 'react-redux'
import HomeIllustrationImage from '~images/onboarding/home_illustration.svg';
import Image from '../../loggedout/common/Image';
import InputWithFloatingLabel from '../../common/floating-input-field/input-with-floating-label';
import SignupAnimation from './SignupAnimation';

const SignupPage = ({ isNextStep, students }) => {
  const [animate, setAnimate] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState({
    emailError: '',
    passwordError: '',
    formError: ''
  });
  const { deleteAll } = useExtendedLocalStorage('splashverse-onboarding', '');

  const { childScreenName, selectedGrade, selectedSubject } = useSelector(state => {
    return {
      childScreenName: state.childScreenName,
      selectedGrade: state.selectedGrade,
      selectedSubject: state.selectedSubject,
    }
  });

  const signUpFormRef = useRef(null);

  useEffect(() => {
    setTimeout(() => {
      setAnimate(true);
    }, 100);
  }, [])

  const validateForm = () => {
    let validateEmailResp = validateEmail(email);
    if (validateEmailResp.validated) {
      setError({ ...error, emailError: '' });
      let validatePasswordResp = validatePassword(password)
      if (validatePasswordResp.validated) {
        setError({ ...error, passwordError: '' });
        return true;
      }
      else {
        setError({ ...error, passwordError: validatePasswordResp.error || "Please try again" });
        return false;
      }
    }
    else {
      setError({ ...error, emailError: validateEmailResp.error || "Please try again" });
      return false;
    }
  }

  const signupBtnHandler = async () => {
    setError({ ...error, passwordError: "", emailError: "", formError: "" })
    const backBtnElement = document.getElementsByClassName("back-btn-container");

    if (validateForm()) {
      try {
        await GuestUserCreation({
          user: {
            type: "parent",
            email: email.trim(),
            password
          },
          rejectWithErrorObject: true,
        });

        //Setting isLoading true to trigger animation
        setIsLoading(true);
        //While on animation, hide the back button
        backBtnElement && backBtnElement.length && backBtnElement[0].style && (backBtnElement[0].style.opacity = 0);

        await SetGradeApi({
          grade_code: selectedGrade,
          student_id: students && students.length && students[0].id ? students[0].id : null,
          onboarding: true,
          screen_name: childScreenName,
        }, true);

        await SetActiveCourse({
          subject_code: selectedSubject,
          onboarding: true,
          complete_onboarding: true,
          email_not_verified: true
        }, true);
        
        deleteAll();
        return location.href = "/parent-dashboard"

      }
      catch (err) {
        const errMsg = err && err.errors && err.errors[0] || err.msg || "Something went wrong, please try again";
        setError({ formError: errMsg })
        //Show back button on error
        backBtnElement && backBtnElement.length && backBtnElement[0].style && (backBtnElement[0].style.opacity = 1);
        setIsLoading(false);
      }
    }
  }

  const emailChangeHandler = (value) => {
    setEmail(value);
    setError({ ...error, emailError: "", formError: "" })
  }

  const passwordChangeHandler = (value) => {
    setPassword(value);
    setError({ ...error, passwordError: "", formError: "" })
  }

  return (
    isLoading ? <SignupAnimation /> :
      <Transition in={animate} timeout={500}>
        {(state) => (
          <S.Container>
            <SS.OnboardingStepWrapper state={state} isNextStep={isNextStep}>
              <SS.StepHeader>
                Create a free account to access {childScreenName}’s learning path
              </SS.StepHeader>
              <SS.StepSubheader>
                {childScreenName}’s progress will be saved with this account
              </SS.StepSubheader>
              <S.FormWrapper ref={signUpFormRef}>
                <form>
                  <div>
                    <InputWithFloatingLabel inputType="email" labelText="Email" onChangeHandler={emailChangeHandler} placeholderText="Enter email/ username" required={true} shouldFocus={true} adjustWithContainer={true} isError={!!error.emailError} />
                    {error.emailError && <S.ErrorElement>{error.emailError}</S.ErrorElement>}
                  </div>
                  <S.PasswordElement>
                    <InputWithFloatingLabel inputType="password" labelText="Password" onChangeHandler={passwordChangeHandler} placeholderText="Create Password" required={true} shouldFocus={false} adjustWithContainer={true} isError={!!error.passwordError} />
                    {error.passwordError && <S.ErrorElement>{error.passwordError}</S.ErrorElement>}
                  </S.PasswordElement>
                  <S.CTAElement>
                    <S.FormError>
                      {error.formError && <S.ErrorElement>{error.formError}</S.ErrorElement>}
                    </S.FormError>
                    <S.SignupBtn type="button" onClick={signupBtnHandler}>Create account for free</S.SignupBtn>
                  </S.CTAElement>
                </form>
              </S.FormWrapper>
              <S.FormFooter>
                By Signing up, you agree to our <a href="/terms-of-use">Terms of use</a> & <a href="/privacy">Privacy policy</a>
              </S.FormFooter>
              <S.ImageWrapper>
                <Image src={HomeIllustrationImage} />
              </S.ImageWrapper>
            </SS.OnboardingStepWrapper>
          </S.Container>
        )}
      </Transition>
  )
}

export default SignupPage;